import React, { useState } from "react";
import MsbNameField from "./MsbNameField";
import { hasErrors } from "../../../../utils";
import { connect } from "react-redux";
import DeviceTypeField from "./DeviceTypeField";
import SelectMsbField from "./SelectMsbField";
import { getMsbByNameIfExists, saveMsb, copyMsbRules } from "../../../ruleService";
import { showDangerToast, showSuccessToast } from "../../../../validation/ToastContainer";
import TargetTypeWizardModal from "../TargetTypeWizardModal";


function CreateMsbModal({ setShowModal, validationErrors, onBack }) {

    const [msb, setMsb] = useState({});
    const [deviceType, setDeviceType] = useState('');
    const [msbId, setMsbId] = useState();

    const onSaveClick = async () => {
        if (deviceType === '-1' || !deviceType) {
            showDangerToast(`Device Type does not exist`, "Save MSB");
            return;
        }

        let serverMsb;
        try {
            serverMsb = await getMsbByNameIfExists(msb.name);
        } catch (error) {
            showDangerToast(error.message || "Unable to check MSB name", "Save MSB");
            return;
        }

        if (serverMsb) {
            showDangerToast(`MSB with name '${msb.name}' already exist`, "Save MSB");
            return;
        }

        let savedMsb;
        try {
            savedMsb = await saveMsb(msb, deviceType, msbId);
        } catch (error) {
            return;
        }

        if (!savedMsb) {
            return;
        }

        if (msbId) {
            const copySucceeded = await copyMsbRules(msbId, savedMsb.id);
            if (!copySucceeded) {
                showDangerToast("MSB created, but rules could not be copied", "Save MSB");
                return;
            }
        }

        showSuccessToast("MSB created", "Save MSB");
        setShowModal(false);

    }

    return (
        <TargetTypeWizardModal
            title="Add MSB Wizard"
            subtitle="Create an MSB and optionally seed it from an existing base."
            onClose={() => setShowModal(false)}
            onBack={onBack}
            onSubmit={onSaveClick}
            submitLabel="Save"
            submitDisabled={hasErrors(validationErrors)}
            contentClassName="target-type-wizard-form__content--first-two-inline"
        >
            <DeviceTypeField deviceType={deviceType} setDeviceType={setDeviceType} />
            <SelectMsbField selectedType={deviceType} setMsbId={setMsbId} msbId={msbId} />
            <MsbNameField msb={msb} setMsb={setMsb} />
        </TargetTypeWizardModal>
    );

}

function mapStateToProps(state) {
    return {
        validationErrors: state.validation
    }
}

export default connect(mapStateToProps)(CreateMsbModal);
